var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feed-card elevate px-2 px-md-3 pt-2 pb-4 mb-3"},[_c('div',{staticClass:"d-flex align-items-center mb-2"},[_c('div',{staticClass:"profilepic mr-1 mr-sm-2"}),_vm._v(" "),_c('div',{staticClass:"name"})]),_vm._v(" "),_c('div',{staticClass:"post-body"},[_c('div',{staticClass:"text"}),_vm._v(" "),_c('div',{staticClass:"image"})])])
}]

export { render, staticRenderFns }